import React, { useEffect, useState } from 'react'
import { Navbar } from '../../Components/Navbar'
import { useDispatch, useSelector } from 'react-redux';
import * as actionTypes from "../../redux/actionTypes";
import AddIcon from '@mui/icons-material/Add';
import { ReactComponent as AddEclIcon } from "../../myfin_v2/assets/icons/addEcl.svg";

//! MUI
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OutlinedInput from "@mui/material/OutlinedInput";
import Card from '@mui/material/Card';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography, Select, FormControl, MenuItem, InputLabel, Checkbox, IconButton, Button } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { getPreset, savePreset, creatingProject, getTB } from '../../services/api/StandAlone/preset';
import swal from 'sweetalert';
import "./presetStyle.css";
import LoaderTwo from '../../Components/Common/Loader/LoaderTwo';
import SelectSheetType from '../../Components/Preset/SelectSheetType';
import SingleFIleFormat from '../../Components/Preset/SingleFIleFormat';
import { useParams, useHistory } from 'react-router';
import { toast } from 'react-toastify';

import { motion } from "framer-motion";
import commoncss from "../../myfin_v2/css/common.module.css"
import saCreationcss from "../../myfin_v2/css/standaloneCreation.module.css"
import { ReactComponent as RightIcon } from "../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg"
import StandaloneProgressBar from "../../WorkSpace/Workspace2/StandaloneProgressBar"
import InputGroup from '../../myfin_v2/elements/InputGroup';
import CustomDropdownIndicator from "../../myfin_v2/elements/CustomDropdownIndicator";


const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

// ─── Shared MUI Select styles (green theme) ────────────────────────────────
const selectSx = {
    width: "180px",
    height: "36px",
    backgroundColor: "#F4FAF5",
    borderRadius: "8px",
    fontSize: "13px",
    fontFamily: "'DM Sans', sans-serif",
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#C2E6D1" },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#C2E6D1" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#C2E6D1" },
};

const menuPropsSx = {
    PaperProps: {
        sx: {
            backgroundColor: '#fff',
            border: '1px solid #C2E6D1',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            marginTop: '4px',
            borderRadius: '8px',
            '& .MuiList-root': {
                padding: '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
            },
            '& .MuiMenuItem-root': {
                color: '#000',
                borderRadius: '6px',
                fontFamily: "'DM Sans', sans-serif",
                '&:hover': {
                    backgroundColor: '#f8f9f9',
                },
                '&.Mui-focusVisible': {
                    backgroundColor: '#f8f9f9',
                },
                '&.Mui-selected': {
                    backgroundColor: '#f4faf5',
                    '&:hover': {
                        backgroundColor: '#f8f9f9',
                    },
                    '&.Mui-focusVisible': {
                        backgroundColor: '#f4faf5',
                    }
                }
            }
        }
    }
};

const inputLabelSx = {
    "&.Mui-focused": { color: "#B3C0BD" },
    fontSize: "14px",
    fontWeight: 500,
    color: "#B3C0BD",
};

// ─── Reusable row: label + checkbox + year select ──────────────────────────
const DropRow = ({ title, itemName, checked, disabled, years, yearValue, onClear, onYearChange }) => (
    <div className='d-flex align-items-start px-3 py-2 mt-1'>
        <div style={{ width: '250px', marginRight: '40px' }}>
            <div style={{ height: '36px', display: 'flex', alignItems: 'center' }}>
                <h6 className='font-size-14 custom-font-400 mb-0' style={{color: "#33584E"}}>{title}</h6>
            </div>
            {itemName && (
                <div className={`${saCreationcss.selItem} mt-2`}>
                    <span className={`${saCreationcss.selItemLabel}`}>{itemName}</span>
                    <IconButton size="small" aria-label="Delete" className='ml-1 p-1' onClick={onClear}><ClearIcon fontSize="small" /></IconButton>
                </div>
            )}
        </div>
        <div className='d-flex align-items-center' style={{ height: '36px' }}>
            <label className="d-flex align-items-center cursor-pointer mr-5 mb-0" style={{fontSize: "13px", color: "#111111"}}>
                <input
                    type="checkbox"
                    checked={checked}
                    disabled={disabled}
                    className={`${commoncss.commonCustomCheckbox} mb-0 mr-2`}
                />
                Include values
            </label>
            <FormControl sx={{ minWidth: 180, m: 0 }} size="small">
                <Select
                    value={yearValue}
                    displayEmpty
                    renderValue={(selected) => {
                        if (!selected) {
                            return <span style={{ color: '#B3C0BD', fontFamily: "'DM Sans', sans-serif" }}>Select year</span>;
                        }
                        return selected;
                    }}
                    input={<OutlinedInput />}
                    IconComponent={ExpandMoreIcon}
                    disabled={disabled}
                    onChange={onYearChange}
                    sx={selectSx}
                    MenuProps={menuPropsSx}
                >
                    {years && years.length > 0 && years.map((y, i) => (
                        y && <MenuItem key={i} value={y}>{y}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    </div>
);

// ─── Draggable item card ────────────────────────────────────────────────────
const DragItem = ({ label: itemLabel, onDragStart }) => (
    <div
        draggable
        className="d-flex align-items-center mt-2 p-1 bg-white cursor-pointer border radius-8px"
        style={{ marginBottom: '8px' }}
        onDragStart={onDragStart}
    >
        <DragIndicatorIcon className='mr-1' fontSize="small" style={{ color: "#DFE2E7"}} />
        <div>
            <p className="m-0 p-0 font-size-14 custom-font-400" style={{ color: "#33584E" }}>{itemLabel}</p>
        </div>
    </div>
);

// ─── Droppable zone wrapper ─────────────────────────────────────────────────
const DropZone = ({ onDrop, children }) => (
    <div
        onDragEnter={(e) => e.preventDefault()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={onDrop}
        onDragLeave={(e) => e.preventDefault()}
    >
        {children}
    </div>
);


const Preset = () => {
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const selectedPresets = useSelector((initialState) => initialState.PresetReducer.selectedPresets);
    const createProjectData = useSelector((initialState) => initialState.PresetReducer.createProjectData);
    const [presetOpt, setPresetOpt] = useState({ preset: [], coa: [], upload_tb_options: [], uploadTbId: null, loading: false });
    const [open, setOpen] = useState(false);
    const [singleFormat, setsingleFormat] = useState(false);
    const [draggedObject, setDraggedObject] = useState(null);

    // ── COA drop state (current + comparative) ──────────────────────────────
    const [coaDropData, setCoaDropData] = useState({
        key: '', name: "", id: '', years: [],
        cy_coa: false, cy_checked: false,
        py_key: '', py_name: "", py_id: '', py_years: [],
        py_coa: false, py_checked: false,
    });

    // ── BS Values drop state (current + comparative) ────────────────────────
    const [bsDropValue, setBsDropValue] = useState({
        key: '', name: "", id: '', years: [],
        cy_value: false, cy_checked: false,
        py_key: '', py_name: "", py_id: '', py_years: [],
        py_value: false, py_checked: false,
    });

    // ── PL Values drop state (current + comparative) ────────────────────────
    const [plDropValue, setPlDropValue] = useState({
        key: '', name: "", id: '', years: [],
        cy_value: false, cy_checked: false,
        py_key: '', py_name: "", py_id: '', py_years: [],
        py_value: false, py_checked: false,
    });

    // ── Year selections ─────────────────────────────────────────────────────
    const [year, setYear] = useState({
        cy_coa: '', cy_bs: '', cy_pl: '',
        py_coa: '', py_bs: '', py_pl: '',
    });

    useEffect(() => {
        setPresetOpt({ ...presetOpt, loading: true });
        getPreset({ presetId: params?.presetId }).then(res => {
            setPresetOpt({
                ...presetOpt,
                coa: res.data?.coa_options,
                preset: res.data?.tb_options,
                upload_tb_options: res.data?.upload_tb_options,
                uploadTbId: res.data?.uploadTBId,
                loading: false
            })
        }).catch(err => {
            setPresetOpt({ ...presetOpt, loading: false });
            swal("Error", err?.response?.data?.error || "Error happening at the time of fetching preset data.", "error")
        })
    }, []);

    // ════════════════════════════════════════════════════════════════════════
    //  DRAG & DROP — COA zone
    // ════════════════════════════════════════════════════════════════════════
    const handleDrop = (e, KEY) => {
        e.preventDefault();
        if (!draggedObject) return;
        if (KEY === 'current') {
            if (draggedObject.key === 'chat_of_account') {
                setCoaDropData({
                    ...coaDropData,
                    cy_coa: true, cy_checked: false,
                    name: draggedObject?.label,
                    id: draggedObject?.value,
                    years: draggedObject?.year,
                    key: draggedObject?.key
                });
                setBsDropValue(prev => ({ ...prev, cy_value: false }));
                setPlDropValue(prev => ({ ...prev, cy_value: false }));
            }
            if (draggedObject.key === 'imported_preset') {
                setCoaDropData({
                    ...coaDropData,
                    cy_coa: false, cy_checked: false,
                    id: draggedObject?.value,
                    key: draggedObject?.key,
                    name: draggedObject?.label,
                    years: draggedObject?.year,
                });
            }
        } else {
            // comparative period
            if (coaDropData.key === "chat_of_account") {
                if (coaDropData.name !== draggedObject?.label) {
                    toast.warning("The selected sheet is different from the current year's COA. Mapping will be based only on the current year's COA.")
                }
            }
            if (draggedObject.key === 'chat_of_account') {
                setCoaDropData({
                    ...coaDropData,
                    py_coa: true, py_checked: false,
                    py_name: draggedObject?.label,
                    py_id: draggedObject?.value,
                    py_years: draggedObject?.year,
                    py_key: draggedObject?.key
                });
                setBsDropValue(prev => ({ ...prev, py_value: false }));
                setPlDropValue(prev => ({ ...prev, py_value: false }));
            }
            if (draggedObject.key === 'imported_preset') {
                setCoaDropData({
                    ...coaDropData,
                    py_coa: false, py_checked: false,
                    py_id: draggedObject?.value,
                    py_key: draggedObject?.key,
                    py_name: draggedObject?.label,
                    py_years: draggedObject?.year,
                });
            }
            if (draggedObject.key === 'uploaded_tb') {
                setCoaDropData({
                    ...coaDropData,
                    py_coa: false, py_checked: false,
                    py_id: draggedObject?.value,
                    py_key: draggedObject?.key,
                    py_name: draggedObject?.label,
                    py_years: draggedObject?.year,
                });
            }
        }
    };

    // ════════════════════════════════════════════════════════════════════════
    //  DRAG & DROP — BS Values zone
    // ════════════════════════════════════════════════════════════════════════
    const handleDropBsValue = (e, KEY) => {
        e.preventDefault();
        if (!draggedObject) return;
        if (KEY === 'current') {
            if (coaDropData.key === 'chat_of_account' && ['imported_preset', 'uploaded_tb'].includes(draggedObject.key)) {
                setBsDropValue({
                    ...bsDropValue,
                    cy_checked: true, cy_value: false,
                    name: draggedObject?.label,
                    id: draggedObject?.value,
                    years: draggedObject?.year,
                    key: draggedObject?.key
                });
            }
            if (coaDropData.key === 'imported_preset') {
                setBsDropValue({
                    ...bsDropValue,
                    cy_checked: false, cy_value: false,
                    name: draggedObject?.label,
                    id: draggedObject?.value,
                    years: draggedObject?.year,
                    key: draggedObject?.key
                });
            }
        } else {
            if (coaDropData.py_key === 'chat_of_account' && ['imported_preset', 'uploaded_tb'].includes(draggedObject.key)) {
                setBsDropValue({
                    ...bsDropValue,
                    py_checked: true, py_value: false,
                    py_name: draggedObject?.label,
                    py_id: draggedObject?.value,
                    py_years: draggedObject?.year,
                    py_key: draggedObject?.key
                });
            }
            if (coaDropData.py_key === 'imported_preset') {
                setBsDropValue({
                    ...bsDropValue,
                    py_checked: false, py_value: false,
                    py_name: draggedObject?.label,
                    py_id: draggedObject?.value,
                    py_years: draggedObject?.year,
                    py_key: draggedObject?.key
                });
            }
        }
    };

    // ════════════════════════════════════════════════════════════════════════
    //  DRAG & DROP — PL Values zone
    // ════════════════════════════════════════════════════════════════════════
    const handleDropPlValue = (e, KEY) => {
        e.preventDefault();
        if (!draggedObject) return;
        if (KEY === 'current') {
            if (coaDropData.key === 'chat_of_account' && ['imported_preset', 'uploaded_tb'].includes(draggedObject.key)) {
                setPlDropValue({
                    ...plDropValue,
                    cy_checked: true, cy_value: false,
                    name: draggedObject?.label,
                    id: draggedObject?.value,
                    years: draggedObject?.year,
                    key: draggedObject?.key
                });
            }
            if (coaDropData.key === 'imported_preset') {
                setPlDropValue({
                    ...plDropValue,
                    cy_checked: false, cy_value: false,
                    name: draggedObject?.label,
                    id: draggedObject?.value,
                    years: draggedObject?.year,
                    key: draggedObject?.key
                });
            }
        } else {
            if (coaDropData.py_key === 'chat_of_account' && ['imported_preset', 'uploaded_tb'].includes(draggedObject.key)) {
                setPlDropValue({
                    ...plDropValue,
                    py_checked: true, py_value: false,
                    py_name: draggedObject?.label,
                    py_id: draggedObject?.value,
                    py_years: draggedObject?.year,
                    py_key: draggedObject?.key
                });
            }
            if (coaDropData.py_key === 'imported_preset') {
                setPlDropValue({
                    ...plDropValue,
                    py_checked: false, py_value: false,
                    py_name: draggedObject?.label,
                    py_id: draggedObject?.value,
                    py_years: draggedObject?.year,
                    py_key: draggedObject?.key
                });
            }
        }
    };

    // ════════════════════════════════════════════════════════════════════════
    //  CLEAR handlers
    // ════════════════════════════════════════════════════════════════════════
    const HandleClear = (key_name) => {
        if (key_name === 'cy_coa') {
            setCoaDropData({ ...coaDropData, cy_coa: false, cy_checked: false, name: '', id: '', years: [], key: '' });
            setBsDropValue(prev => ({ ...prev, cy_value: false }));
            setPlDropValue(prev => ({ ...prev, cy_value: false }));
            setYear(prev => ({ ...prev, cy_coa: "" }));
        }
        if (key_name === 'cy_bs') {
            setBsDropValue({ ...bsDropValue, cy_checked: false, cy_value: false, name: '', id: '', years: [], key: '' });
            setYear(prev => ({ ...prev, cy_bs: "" }));
        }
        if (key_name === 'cy_pl') {
            setPlDropValue({ ...plDropValue, cy_checked: false, cy_value: false, name: '', id: '', years: [], key: '' });
            setYear(prev => ({ ...prev, cy_pl: "" }));
        }
        if (key_name === 'py_coa') {
            setCoaDropData({ ...coaDropData, py_checked: false, py_coa: false, py_name: '', py_id: '', py_years: [], py_key: '' });
            setBsDropValue(prev => ({ ...prev, py_value: false }));
            setPlDropValue(prev => ({ ...prev, py_value: false }));
            setYear(prev => ({ ...prev, py_coa: "" }));
        }
        if (key_name === 'py_bs') {
            setBsDropValue({ ...bsDropValue, py_checked: false, py_value: false, py_name: '', py_id: '', py_years: [], py_key: '' });
            setYear(prev => ({ ...prev, py_bs: "" }));
        }
        if (key_name === 'py_pl') {
            setPlDropValue({ ...plDropValue, py_checked: false, py_value: false, py_name: '', py_id: '', py_years: [], py_key: '' });
            setYear(prev => ({ ...prev, py_pl: "" }));
        }
    };

    // ════════════════════════════════════════════════════════════════════════
    //  YEAR CHANGE handlers
    // ════════════════════════════════════════════════════════════════════════
    const HandleYearChange = (e, KEY_NAME) => {
        // ── Current period — COA ──────────────────────────────────────────
        if (KEY_NAME === 'COA-CY') {
            if (coaDropData.key === 'imported_preset') {
                setYear(prev => ({ ...prev, cy_coa: e.target.value }));
                setBsDropValue(prev => ({ ...prev, cy_checked: false, cy_value: true }));
                setPlDropValue(prev => ({ ...prev, cy_checked: false, cy_value: true }));
                setCoaDropData(prev => ({ ...prev, cy_checked: true, cy_coa: false }));
            } else {
                setYear(prev => ({ ...prev, cy_coa: e.target.value }));
            }
        }

        // ── Current period — BS Values ────────────────────────────────────
        if (KEY_NAME === 'BS-CY') {
            if (coaDropData.key === 'imported_preset') {
                setYear(prev => ({ ...prev, cy_bs: e.target.value }));
                setCoaDropData(prev => ({ ...prev, cy_checked: false, cy_coa: true }));
                setBsDropValue(prev => ({ ...prev, cy_checked: true, cy_value: false }));
            } else {
                setYear(prev => ({ ...prev, cy_bs: e.target.value }));
            }
        }

        // ── Current period — PL Values ────────────────────────────────────
        if (KEY_NAME === 'PL-CY') {
            if (coaDropData.key === 'imported_preset') {
                setYear(prev => ({ ...prev, cy_pl: e.target.value }));
                setCoaDropData(prev => ({ ...prev, cy_checked: false, cy_coa: true }));
                setPlDropValue(prev => ({ ...prev, cy_checked: true, cy_value: false }));
            } else {
                setYear(prev => ({ ...prev, cy_pl: e.target.value }));
            }
        }

        // ── Comparative period — COA ──────────────────────────────────────
        if (KEY_NAME === 'COA-PY') {
            if (['imported_preset', 'uploaded_tb'].includes(coaDropData.py_key)) {
                setYear(prev => ({ ...prev, py_coa: e.target.value }));
                setBsDropValue(prev => ({ ...prev, py_checked: false, py_value: true }));
                setPlDropValue(prev => ({ ...prev, py_checked: false, py_value: true }));
                setCoaDropData(prev => ({ ...prev, py_checked: true, py_coa: false }));
            } else {
                setYear(prev => ({ ...prev, py_coa: e.target.value }));
            }
        }

        // ── Comparative period — BS Values ────────────────────────────────
        if (KEY_NAME === 'BS-PY') {
            if (coaDropData.py_key === 'imported_preset') {
                setYear(prev => ({ ...prev, py_bs: e.target.value }));
                setCoaDropData(prev => ({ ...prev, py_checked: false, py_coa: true }));
                setBsDropValue(prev => ({ ...prev, py_checked: true, py_value: false }));
            } else {
                setYear(prev => ({ ...prev, py_bs: e.target.value }));
            }
        }

        // ── Comparative period — PL Values ────────────────────────────────
        if (KEY_NAME === 'PL-PY') {
            if (coaDropData.py_key === 'imported_preset') {
                setYear(prev => ({ ...prev, py_pl: e.target.value }));
                setCoaDropData(prev => ({ ...prev, py_checked: false, py_coa: true }));
                setPlDropValue(prev => ({ ...prev, py_checked: true, py_value: false }));
            } else {
                setYear(prev => ({ ...prev, py_pl: e.target.value }));
            }
        }
    };

     const HandleCreatePreset = () => {
        const data = {
            presetId: params?.presetId,
            uploadTbId: presetOpt.uploadTbId,

           currentPeriod: {
                coa: {
                    key: coaDropData.key,
                    id: coaDropData.id,
                    year: year.cy_coa,
                },
                bsValues: {
                    key: bsDropValue.key,
                    id: bsDropValue.id,
                    year: year.cy_bs,
                },
                plValues: {
                    key: plDropValue.key,
                    id: plDropValue.id,
                    year: year.cy_pl,
                },
            },
            comparativePeriodConfig: {
                coa: {
                    key: coaDropData.py_key,
                    id: coaDropData.py_id,
                    year: year.py_coa,
                },
                bsValues: {
                    key: bsDropValue.py_key,
                    id: bsDropValue.py_id,
                    year: year.py_bs,
                },
                plValues: {
                    key: plDropValue.py_key,
                    id: plDropValue.py_id,
                    year: year.py_pl,
                },
            },

            yearPp: year.py_coa || year.py_bs || year.py_pl,
            idPp: coaDropData.py_id || bsDropValue.py_id || plDropValue.py_id,
            keyPp: coaDropData.py_key || bsDropValue.py_key || plDropValue.py_key,
            coaIdCp: coaDropData.key === "chat_of_account" ? coaDropData.id : null,
            coaIdPP: coaDropData.py_key === "chat_of_account" ? coaDropData.py_id : null,
            keys: {
                coaKeyCP: coaDropData.key,
                valueKeyCP: bsDropValue.key,       // BS used as primary "value" for legacy
                coaKeyPP: coaDropData.py_key,
                valueKeyPP: bsDropValue.py_key,    // BS used as primary "value" for legacy
            },
            ids: {
                coaIdCP: coaDropData.id,
                valueIdCP: bsDropValue.id,
                coaIdPP: coaDropData.py_id,
                valueIdPP: bsDropValue.py_id,
            },
            years: {
                coaYearCP: year.cy_coa,
                valueYearCP: year.cy_bs,
                coaYearPP: year.py_coa,
                valueYearPP: year.py_bs,
            },
        };

        savePreset(data).then(res => {
            if (res.data.success) {
                swal("Success", `Data saved successfully, Click Ok to redirect for mapping data.`, {
                    icon: "success",
                }).then(() => {
                    creatingProject({ presetId: params?.presetId, coaProjectId: res.data.coaProjectId }).then(res => {
                        dispatch({
                            type: actionTypes.SET_TB_ID,
                            payload: res.data.tb_id,
                        });
                        window.localStorage.setItem("tb_id", res.data.tb_id);
                        window.localStorage.setItem("project_id", res.data.projectId);
                         history.push(`/templateV2/${res.data?.projectId}`);
                        //history.push(`/createProject/DataMapping/${res.data?.projectId}`);
                    }).catch(err => swal("Error", "Error happening creating project.", "error"))
                })
            }
        }).catch(err => {
            swal("Error", err?.response?.data?.error || "Error happening save preset mapping.", "error")
        });
    };

    return (
        <>
            <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
                <div>
                    <StandaloneProgressBar ActiveStage={1} />
                </div>
                <div>
                    <motion.div
                        initial={{ x: 500, y: 500, opacity: 0 }}
                        animate={{ x: 0, y: 0, opacity: 1 }}
                        exit={{ x: 0, y: 0, opacity: 0 }}
                        transition={{ duration: 0.7, ease: "easeInOut" }}
                        className={saCreationcss.wsCrtNameDiv}
                        style={{ paddingTop: "20px" }}
                    >
                        {/* ── Header ───────────────────────────────────────────────── */}
                        <div className="d-flex justify-content-between align-items-center" style={{ width: "98%" }}>
                            <span className={`${saCreationcss.wsCreationCatHeading} ${commoncss.fs22}`}>
                                Map COA
                            </span>
                            <button
                                style={{ border: "1px solid #7ECEA7", borderRadius: "8px", padding: "7px 12px", fontSize: "13px", color: "#1A4338", background: "transparent" }}
                                onClick={() => setOpen(true)}
                            >
                                <AddEclIcon style={{ marginRight: "3px", marginTop: "-3px", width: "16px", height: "16px" }} />
                                Upload TB
                            </button>
                        </div>

                        {/* ── Body ─────────────────────────────────────────────────── */}
                        <div className={`${commoncss.inputCol}`} style={{ width: "98%" }}>

                            <div className='mt-3'>
                                <div className="row">

                                    {/* ════════════════════════════════════════════════════
                                        LEFT COLUMN — Current & Comparative period cards
                                    ════════════════════════════════════════════════════ */}
                                    <div className="col-sm-8 scroll-y-preset" style={{ height: "62vh" }}>

                                        {/* ── CURRENT PERIOD card ──────────────────────── */}
                                        <div className={`${saCreationcss.presetCard}`}>
                                            <div className={`${saCreationcss.presetCardHead1}`}>
                                                Current period
                                            </div>

                                            {/* COA drop zone */}
                                            <DropZone onDrop={(e) => handleDrop(e, 'current')}>
                                                <DropRow
                                                    title="Chart of accounts"
                                                    itemName={coaDropData?.name}
                                                    checked={coaDropData.cy_checked}
                                                    disabled={coaDropData.cy_coa}
                                                    years={coaDropData?.years}
                                                    yearValue={year.cy_coa}
                                                    onClear={() => HandleClear('cy_coa')}
                                                    onYearChange={(e) => HandleYearChange(e, "COA-CY")}
                                                />
                                            </DropZone>

                                            {/* BS Values drop zone */}
                                            <DropZone onDrop={(e) => handleDropBsValue(e, 'current')}>
                                                <DropRow
                                                    title="Balance Sheet Values"
                                                    itemName={bsDropValue?.name}
                                                    checked={bsDropValue.cy_checked}
                                                    disabled={bsDropValue.cy_value}
                                                    years={bsDropValue?.years}
                                                    yearValue={year.cy_bs}
                                                    onClear={() => HandleClear('cy_bs')}
                                                    onYearChange={(e) => HandleYearChange(e, "BS-CY")}
                                                />
                                            </DropZone>

                                            {/* PL Values drop zone */}
                                            <DropZone onDrop={(e) => handleDropPlValue(e, 'current')}>
                                                <DropRow
                                                    title="Profit and Loss Values"
                                                    itemName={plDropValue?.name}
                                                    checked={plDropValue.cy_checked}
                                                    disabled={plDropValue.cy_value}
                                                    years={plDropValue?.years}
                                                    yearValue={year.cy_pl}
                                                    onClear={() => HandleClear('cy_pl')}
                                                    onYearChange={(e) => HandleYearChange(e, "PL-CY")}
                                                />
                                            </DropZone>

                                            {/* Additional Journals (disabled — unchanged) */}
                                            <div className='d-flex align-items-start px-3 py-2 mt-1'>
                                                <div style={{ width: '250px', marginRight: '40px' }}>
                                                    <div style={{ height: '36px', display: 'flex', alignItems: 'center' }}>
                                                        <h6 className='font-size-14 custom-font-400 mb-0' style={{color: "#33584E"}}>Additional Journals</h6>
                                                    </div>
                                                </div>
                                                <div className='d-flex align-items-center' style={{ height: '36px' }}>
                                                    <label className="d-flex align-items-center cursor-pointer mr-5 mb-0" style={{fontSize: "13px", color: "#111111"}}>
                                                        <input
                                                            type="checkbox"
                                                            disabled={true}
                                                            className={`${commoncss.commonCustomCheckbox} mb-0 mr-2`}
                                                        />
                                                        Include values
                                                    </label>
                                                    <FormControl sx={{ minWidth: 180, m: 0 }} size="small">
                                                        <Select
                                                            value=""
                                                            displayEmpty
                                                            renderValue={(selected) => {
                                                                if (!selected) {
                                                                    return <span style={{ color: '#B3C0BD', fontFamily: "'DM Sans', sans-serif" }}>Select year</span>;
                                                                }
                                                                return selected;
                                                            }}
                                                            input={<OutlinedInput />}
                                                            IconComponent={ExpandMoreIcon}
                                                            disabled
                                                            sx={selectSx}
                                                            MenuProps={menuPropsSx}
                                                        >
                                                            <MenuItem value=""><em>None</em></MenuItem>
                                                            <MenuItem value={"3/31/2022"}>3/31/2022</MenuItem>
                                                            <MenuItem value={"3/31/2023"}>3/31/2023</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>

                                        {/* ── COMPARATIVE PERIOD card ───────────────────── */}
                                        <div className={`${saCreationcss.presetCard} mt-3`}>
                                            <div className={saCreationcss.presetCardHead1}>
                                                Comparative period
                                            </div>

                                            {/* COA drop zone */}
                                            <DropZone onDrop={(e) => handleDrop(e, 'comparitive')}>
                                                <DropRow
                                                    title="Chart of accounts"
                                                    itemName={coaDropData?.py_name}
                                                    checked={coaDropData.py_checked}
                                                    disabled={coaDropData.py_coa}
                                                    years={coaDropData?.py_years}
                                                    yearValue={year.py_coa}
                                                    onClear={() => HandleClear('py_coa')}
                                                    onYearChange={(e) => HandleYearChange(e, "COA-PY")}
                                                />
                                            </DropZone>

                                            {/* BS Values drop zone */}
                                            <DropZone onDrop={(e) => handleDropBsValue(e, 'comparitive')}>
                                                <DropRow
                                                    title="Balance Sheet Values"
                                                    itemName={bsDropValue?.py_name}
                                                    checked={bsDropValue.py_checked}
                                                    disabled={bsDropValue.py_value}
                                                    years={bsDropValue?.py_years}
                                                    yearValue={year.py_bs}
                                                    onClear={() => HandleClear('py_bs')}
                                                    onYearChange={(e) => HandleYearChange(e, "BS-PY")}
                                                />
                                            </DropZone>

                                            {/* PL Values drop zone */}
                                            <DropZone onDrop={(e) => handleDropPlValue(e, 'comparitive')}>
                                                <DropRow
                                                    title="Profit and Loss Values"
                                                    itemName={plDropValue?.py_name}
                                                    checked={plDropValue.py_checked}
                                                    disabled={plDropValue.py_value}
                                                    years={plDropValue?.py_years}
                                                    yearValue={year.py_pl}
                                                    onClear={() => HandleClear('py_pl')}
                                                    onYearChange={(e) => HandleYearChange(e, "PL-PY")}
                                                />
                                            </DropZone>

                                            {/* Additional Journals (disabled — unchanged) */}
                                            <div className='d-flex align-items-start px-3 py-2 mt-1'>
                                                <div style={{ width: '250px', marginRight: '40px' }}>
                                                    <div style={{ height: '36px', display: 'flex', alignItems: 'center' }}>
                                                        <h6 className='font-size-14 custom-font-400 mb-0' style={{color: "#33584E"}}>Additional Journals</h6>
                                                    </div>
                                                </div>
                                                <div className='d-flex align-items-center' style={{ height: '36px' }}>
                                                    <label className="d-flex align-items-center cursor-pointer mr-5 mb-0" style={{fontSize: "13px", color: "#111111"}}>
                                                        <input
                                                            type="checkbox"
                                                            disabled={true}
                                                            className={`${commoncss.commonCustomCheckbox} mb-0 mr-2`}
                                                        />
                                                        Include values
                                                    </label>
                                                    <FormControl sx={{ minWidth: 180, m: 0 }} size="small">
                                                        <Select
                                                            value=""
                                                            displayEmpty
                                                            renderValue={(selected) => {
                                                                if (!selected) {
                                                                    return <span style={{ color: '#B3C0BD', fontFamily: "'DM Sans', sans-serif" }}>Select year</span>;
                                                                }
                                                                return selected;
                                                            }}
                                                            input={<OutlinedInput />}
                                                            IconComponent={ExpandMoreIcon}
                                                            disabled
                                                            sx={selectSx}
                                                            MenuProps={menuPropsSx}
                                                        >
                                                            <MenuItem className='text-secondary' value=""><em>None</em></MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* ════════════════════════════════════════════════════
                                        RIGHT COLUMN — Draggable source panels
                                    ════════════════════════════════════════════════════ */}
                                    <div className="col-sm-4 scroll-y-preset" style={{ height: "62vh" }}>

                                        {/* Imported Presets */}
                                        <div className={`${saCreationcss.presetCard}`}>
                                            <div className={saCreationcss.presetCardHead2}>Imported Presets</div>
                                            <div className='p-2 preset-map-div'>
                                                {presetOpt?.loading
                                                    ? <div className='d-flex justify-content-center'><LoaderTwo /></div>
                                                    : presetOpt?.preset.length > 0
                                                        ? presetOpt?.preset.map((coaEle, cx) => (
                                                            <DragItem
                                                                key={cx}
                                                                label={coaEle?.label}
                                                                onDragStart={() => setDraggedObject({ ...coaEle, key: "imported_preset" })}
                                                            />
                                                        ))
                                                        : <Typography>Preset data not found.</Typography>
                                                }
                                            </div>
                                        </div>

                                        {/* Chart of Accounts */}
                                        <div className={`${saCreationcss.presetCard} mt-3`}>
                                            <div className={saCreationcss.presetCardHead2}>Chart of accounts</div>
                                            <div className='p-2 preset-map-div'>
                                                {presetOpt?.loading
                                                    ? <div className='d-flex justify-content-center'><LoaderTwo /></div>
                                                    : presetOpt?.coa.length > 0
                                                        ? presetOpt?.coa.map((coaEle, cx) => (
                                                            coaEle?.label
                                                                ? <DragItem
                                                                    key={cx}
                                                                    label={coaEle?.label}
                                                                    onDragStart={() => setDraggedObject({ ...coaEle, key: "chat_of_account" })}
                                                                />
                                                                : null
                                                        ))
                                                        : <Typography>COA data not found.</Typography>
                                                }
                                            </div>
                                        </div>

                                        {/* Uploaded TB */}
                                        <div className={`${saCreationcss.presetCard} mt-3`}>
                                            <div className={saCreationcss.presetCardHead2}>Uploaded TB</div>
                                            <div className='p-2 preset-map-div'>
                                                {presetOpt?.loading
                                                    ? <div className='d-flex justify-content-center'><LoaderTwo /></div>
                                                    : presetOpt?.upload_tb_options?.length > 0
                                                        ? presetOpt?.upload_tb_options?.map((coaEle, cx) => (
                                                            <DragItem
                                                                key={cx}
                                                                label={coaEle?.label}
                                                                onDragStart={() => setDraggedObject({ ...coaEle, key: "uploaded_tb" })}
                                                            />
                                                        ))
                                                        : (
                                                            <div className='p-2 mt-1 text-center'>
                                                                <div className='mt-5'>
                                                                    <p className="m-0 p-0 font-size-16 custom-font-400" style={{ color: "#ABA9A9" }}>Please Upload TB</p>
                                                                </div>
                                                            </div>
                                                        )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>

                    {/* ── Footer ───────────────────────────────────────────────────── */}
                    <div className={saCreationcss.footerContainer}>
                        <div>
                            <button
                                onClick={() => {
                                    if (createProjectData?.workspace_id) {
                                        history.push(`/financialstatement/${createProjectData.workspace_id}`);
                                    } else {
                                        history.push('/dashboard');
                                    }
                                }}
                                className={saCreationcss.cancelBtn}
                                type="button"
                                style={{ padding: "7px" }}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className={saCreationcss.footerbtnContainer}>
                            <button
                                className={saCreationcss.saveBtn}
                                type="button"
                                onClick={() => HandleCreatePreset()}
                                style={{ padding: "7px" }}
                            >
                                {"Save and Proceed"} &nbsp;<RightIcon />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Hidden old layout (kept as-is, untouched) ──────────────────────── */}
            <div hidden>
                <div className="px-5 w-100 py-3">
                    <div className="row justify-content-between">
                        <div className="col-md-8 col-sm-12 mb-3">
                            <button
                                className="d-flex custom-font-600 custom-common-theme-text-color border-0 bg-color-inherit"
                                onClick={() => {
                                    if (!createProjectData?.workspace_id) return toast.warning("Workspace id is missing.")
                                    history.push(`/createProject/QuestionnaireNew/${createProjectData.workspace_id}`)
                                }}
                            >
                                <ArrowBackIcon className="mr-1" /> Back
                            </button>
                        </div>
                        <div className="col-md-4 col-sm-12 d-flex " style={{ gap: "30px" }}>
                            <button className="bg-white border-color custom-common-theme-text-color custom-font-600 font-size-16 w-25 radius-6px" onClick={() => setOpen(true)}>Upload TB</button>
                            <button
                                className="bg-white w-75 d-flex justify-content-center align-items-center border-color custom-common-theme-text-color custom-font-600 font-size-16 radius-6px"
                                onClick={() => HandleCreatePreset()}
                            >
                                <AddIcon className='mr-1' />
                                Create financial statement
                            </button>
                        </div>
                    </div>

                    <div className='mt-4'>
                        <div className="row">
                            <div className="col-sm-8 scroll-y-preset">
                                <Card className='bg-white custom-card radius-12px'>
                                    <div className='d-flex align-items-start bg-light-blue'>
                                        <h6 className='mt-2 p-2 ml-3 font-size-16 custom-font-600'>Current period</h6>
                                    </div>
                                    <div
                                        className='p-2 mt-1'
                                        onDragEnter={(e) => e.preventDefault()}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDrop(e, 'current')}
                                        onDragLeave={(e) => e.preventDefault()}
                                    >
                                        <h6 className='ml-3 font-size-14 custom-font-600'>Chart of accounts</h6>
                                        {coaDropData?.name && (
                                            <div className='d-flex ml-4'>
                                                <Typography className='text-secondary custom-font-500'>{coaDropData?.name}</Typography>
                                                <IconButton aria-label="Delete" className='ml-2' onClick={() => HandleClear('cy_coa')}><ClearIcon /></IconButton>
                                            </div>
                                        )}
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox checked={coaDropData.cy_checked} disabled={coaDropData.cy_coa} {...label} />
                                            <p className={`m-0 ${coaDropData.cy_coa ? "include-value-d" : "include-value"} font-sans`}>Include values</p>
                                            <div>
                                                <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                    <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                    <Select
                                                        labelId="demo-select-small-label"
                                                        className='radius-8px text-secondary'
                                                        value={year.cy_coa}
                                                        label="Select"
                                                        disabled={coaDropData.cy_coa}
                                                        onChange={(e) => HandleYearChange(e, "COA-CY")}
                                                    >
                                                        {coaDropData?.years && coaDropData?.years.length > 0 && coaDropData?.years.map((y, i) => (
                                                            y && <MenuItem className='text-secondary' key={i} value={y}>{y}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                    </div>
                                    {/* BS Values (old layout) */}
                                    <div
                                        className='p-2'
                                        onDragEnter={(e) => e.preventDefault()}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDropBsValue(e, 'current')}
                                        onDragLeave={(e) => e.preventDefault()}
                                    >
                                        <h6 className='ml-3 font-size-14 custom-font-600'>Balance Sheet Values</h6>
                                        {bsDropValue?.name && (
                                            <div className='d-flex ml-4'>
                                                <Typography className='text-secondary custom-font-500'>{bsDropValue?.name}</Typography>
                                                <IconButton aria-label="Delete" className='ml-2' onClick={() => HandleClear('cy_bs')}><ClearIcon /></IconButton>
                                            </div>
                                        )}
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox checked={bsDropValue.cy_checked} disabled={bsDropValue.cy_value} {...label} />
                                            <Typography className='font-sans'>Include values</Typography>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select
                                                    labelId="demo-select-small-label"
                                                    className='radius-8px text-secondary'
                                                    value={year.cy_bs}
                                                    label="Year"
                                                    disabled={bsDropValue.cy_value}
                                                    onChange={(e) => HandleYearChange(e, "BS-CY")}
                                                >
                                                    {bsDropValue?.years && bsDropValue?.years.length > 0 && bsDropValue?.years.map((y, i) => (
                                                        y && <MenuItem className='text-secondary' key={i} value={y}>{y}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {/* PL Values (old layout) */}
                                    <div
                                        className='p-2'
                                        onDragEnter={(e) => e.preventDefault()}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDropPlValue(e, 'current')}
                                        onDragLeave={(e) => e.preventDefault()}
                                    >
                                        <h6 className='ml-3 font-size-14 custom-font-600'>Profit and Loss Values</h6>
                                        {plDropValue?.name && (
                                            <div className='d-flex ml-4'>
                                                <Typography className='text-secondary custom-font-500'>{plDropValue?.name}</Typography>
                                                <IconButton aria-label="Delete" className='ml-2' onClick={() => HandleClear('cy_pl')}><ClearIcon /></IconButton>
                                            </div>
                                        )}
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox checked={plDropValue.cy_checked} disabled={plDropValue.cy_value} {...label} />
                                            <Typography className='font-sans'>Include values</Typography>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select
                                                    labelId="demo-select-small-label"
                                                    className='radius-8px text-secondary'
                                                    value={year.cy_pl}
                                                    label="Year"
                                                    disabled={plDropValue.cy_value}
                                                    onChange={(e) => HandleYearChange(e, "PL-CY")}
                                                >
                                                    {plDropValue?.years && plDropValue?.years.length > 0 && plDropValue?.years.map((y, i) => (
                                                        y && <MenuItem className='text-secondary' key={i} value={y}>{y}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {/* Additional Journals (old layout — disabled) */}
                                    <div className='p-2'>
                                        <h6 className='ml-3 font-size-14 custom-font-500'>Additional Journals</h6>
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox disabled={true} {...label} />
                                            <Typography className='font-sans'>Include values</Typography>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select labelId="demo-select-small-label" className='radius-8px text-secondary' label="Year" disabled>
                                                    <MenuItem value=""><em>None</em></MenuItem>
                                                    <MenuItem value={"3/31/2022"}>3/31/2022</MenuItem>
                                                    <MenuItem value={"3/31/2023"}>3/31/2023</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </Card>

                                {/* Comparative period (old layout) */}
                                <Card className='bg-white mt-5 custom-card radius-12px'>
                                    <div className='d-flex align-items-start bg-light-blue'>
                                        <h6 className='mt-2 p-2 ml-3 font-size-16 custom-font-600'>Comparative period</h6>
                                    </div>
                                    <div
                                        className='p-2 mt-1'
                                        onDragEnter={(e) => e.preventDefault()}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDrop(e, 'comparitive')}
                                        onDragLeave={(e) => e.preventDefault()}
                                    >
                                        <h6 className='ml-3 font-size-14 custom-font-600'>Chart of accounts</h6>
                                        {coaDropData?.py_name && (
                                            <div className='d-flex ml-4'>
                                                <Typography className='text-secondary custom-font-500'>{coaDropData?.py_name}</Typography>
                                                <IconButton aria-label="Delete" className='ml-2' onClick={() => HandleClear('py_coa')}><ClearIcon /></IconButton>
                                            </div>
                                        )}
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox checked={coaDropData.py_checked} disabled={coaDropData.py_coa} {...label} />
                                            <p className={`m-0 ${coaDropData.py_coa ? "include-value-d" : "include-value"}`}>Include values</p>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select
                                                    labelId="demo-select-small-label"
                                                    className='radius-8px text-secondary'
                                                    value={year.py_coa}
                                                    label="Year"
                                                    disabled={coaDropData.py_coa}
                                                    onChange={(e) => HandleYearChange(e, "COA-PY")}
                                                >
                                                    {coaDropData?.py_years && coaDropData?.py_years.length > 0 && coaDropData?.py_years.map((y, i) => (
                                                        y && <MenuItem className='text-secondary' key={i} value={y}>{y}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {/* BS Values comparative (old layout) */}
                                    <div
                                        className='p-2'
                                        onDragEnter={(e) => e.preventDefault()}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDropBsValue(e, 'comparitive')}
                                        onDragLeave={(e) => e.preventDefault()}
                                    >
                                        <h6 className='ml-3 font-size-14 custom-font-600'>Balance Sheet Values</h6>
                                        {bsDropValue?.py_name && (
                                            <div className='d-flex ml-4'>
                                                <Typography className='text-secondary custom-font-500'>{bsDropValue?.py_name}</Typography>
                                                <IconButton aria-label="Delete" className='ml-2' onClick={() => HandleClear('py_bs')}><ClearIcon /></IconButton>
                                            </div>
                                        )}
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox checked={bsDropValue.py_checked} disabled={bsDropValue.py_value} {...label} />
                                            <Typography className='font-sans'>Include values</Typography>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select
                                                    labelId="demo-select-small-label"
                                                    className='radius-8px text-secondary'
                                                    value={year.py_bs}
                                                    label="Year"
                                                    disabled={bsDropValue.py_value}
                                                    onChange={(e) => HandleYearChange(e, "BS-PY")}
                                                >
                                                    {bsDropValue?.py_years && bsDropValue?.py_years.length > 0 && bsDropValue?.py_years.map((y, i) => (
                                                        y && <MenuItem className='text-secondary' key={i} value={y}>{y}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {/* PL Values comparative (old layout) */}
                                    <div
                                        className='p-2'
                                        onDragEnter={(e) => e.preventDefault()}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={(e) => handleDropPlValue(e, 'comparitive')}
                                        onDragLeave={(e) => e.preventDefault()}
                                    >
                                        <h6 className='ml-3 font-size-14 custom-font-600'>Profit and Loss Values</h6>
                                        {plDropValue?.py_name && (
                                            <div className='d-flex ml-4'>
                                                <Typography className='text-secondary custom-font-500'>{plDropValue?.py_name}</Typography>
                                                <IconButton aria-label="Delete" className='ml-2' onClick={() => HandleClear('py_pl')}><ClearIcon /></IconButton>
                                            </div>
                                        )}
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox checked={plDropValue.py_checked} disabled={plDropValue.py_value} {...label} />
                                            <Typography className='font-sans'>Include values</Typography>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select
                                                    labelId="demo-select-small-label"
                                                    className='radius-8px text-secondary'
                                                    value={year.py_pl}
                                                    label="Year"
                                                    disabled={plDropValue.py_value}
                                                    onChange={(e) => HandleYearChange(e, "PL-PY")}
                                                >
                                                    {plDropValue?.py_years && plDropValue?.py_years.length > 0 && plDropValue?.py_years.map((y, i) => (
                                                        y && <MenuItem className='text-secondary' key={i} value={y}>{y}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                    {/* Additional Journals comparative (old layout — disabled) */}
                                    <div className='p-2'>
                                        <h6 className='ml-3 font-size-14 custom-font-500'>Additional Journals</h6>
                                        <div className='d-flex align-items-center ml-3'>
                                            <Checkbox disabled {...label} />
                                            <Typography className='font-sans'>Include values</Typography>
                                            <FormControl sx={{ m: 1, minWidth: 180 }} className='custom-bg-white-150' size="small">
                                                <InputLabel className='text-secondary' id="demo-select-small-label">Select Year</InputLabel>
                                                <Select disabled labelId="demo-select-small-label" className='radius-8px text-secondary' label="Year">
                                                    <MenuItem className='text-secondary' value=""><em>None</em></MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            {/* Right column (old layout) */}
                            <div className="col-sm-4 scroll-y-preset">
                                <Card className='bg-white custom-card radius-12px'>
                                    <div className='d-flex align-items-start custom-bg-warning-200'>
                                        <h6 className='mt-2 p-2 ml-3 font-size-16 custom-font-600'>Imported Presets</h6>
                                    </div>
                                    <div className='p-2 preset-map-div'>
                                        {presetOpt?.loading
                                            ? <div className='d-flex justify-content-center'><LoaderTwo /></div>
                                            : presetOpt?.preset.length > 0
                                                ? presetOpt?.preset.map((coaEle, cx) => (
                                                    <div key={cx} draggable className="d-flex align-items-center mt-2 p-2 bg-white cursor-pointer border radius-8px"
                                                        onDragStart={() => setDraggedObject({ ...coaEle, key: "imported_preset" })}>
                                                        <DragIndicatorIcon className='mr-1' style={{ color: "#DFE2E7" }} />
                                                        <p className="m-0 p-0 font-size-16 custom-font-400" style={{ color: "#ABA9A9" }}>{coaEle?.label}</p>
                                                    </div>
                                                ))
                                                : <Typography>Preset data not found.</Typography>
                                        }
                                    </div>
                                </Card>
                                <Card className='bg-white mt-3 custom-card radius-12px'>
                                    <div className='d-flex align-items-start custom-bg-warning-200'>
                                        <h6 className='mt-2 p-2 ml-3 font-size-16 custom-font-600'>Chart of accounts</h6>
                                    </div>
                                    <div className='p-2 preset-map-div'>
                                        {presetOpt?.loading
                                            ? <div className='d-flex justify-content-center'><LoaderTwo /></div>
                                            : presetOpt?.coa.length > 0
                                                ? presetOpt?.coa.map((coaEle, cx) => (
                                                    coaEle?.label
                                                        ? <div key={cx} draggable className="d-flex align-items-center mt-2 p-2 bg-white cursor-pointer border radius-8px"
                                                            onDragStart={() => setDraggedObject({ ...coaEle, key: "chat_of_account" })}>
                                                            <DragIndicatorIcon className='mr-1' style={{ color: "#DFE2E7" }} />
                                                            <p className="m-0 p-0 font-size-16 custom-font-400" style={{ color: "#ABA9A9" }}>{coaEle?.label}</p>
                                                        </div>
                                                        : null
                                                ))
                                                : <Typography>COA data not found.</Typography>
                                        }
                                    </div>
                                </Card>
                                <Card className='bg-white mt-3 custom-card radius-12px'>
                                    <div className='d-flex align-items-start custom-bg-warning-200'>
                                        <h6 className='mt-2 p-2 ml-3 font-size-16 custom-font-600'>Uploaded TB</h6>
                                    </div>
                                    <div className='p-2 preset-map-div'>
                                        {presetOpt?.loading
                                            ? <div className='d-flex justify-content-center'><LoaderTwo /></div>
                                            : presetOpt?.upload_tb_options?.length > 0
                                                ? presetOpt?.upload_tb_options?.map((coaEle, cx) => (
                                                    <div key={cx} draggable className="d-flex align-items-center mt-2 p-2 bg-white cursor-pointer border radius-8px"
                                                        onDragStart={() => setDraggedObject({ ...coaEle, key: "uploaded_tb" })}>
                                                        <DragIndicatorIcon className='mr-1' style={{ color: "#DFE2E7" }} />
                                                        <p className="m-0 p-0 font-size-16 custom-font-400" style={{ color: "#ABA9A9" }}>{coaEle?.label}</p>
                                                    </div>
                                                ))
                                                : <div className='p-2 mt-1 text-center'><div className='mt-5'><p className="m-0 p-0 font-size-16 custom-font-400" style={{ color: "#ABA9A9" }}>Please Upload TB</p></div></div>
                                        }
                                    </div>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* FIX 5: setsingleFormat correctly passed to SelectSheetType so the single file flow works */}
            <SelectSheetType setOpen={setOpen} setsingleFormat={setsingleFormat} open={open} presetId={params?.presetId} />
            <SingleFIleFormat setsingleFormat={setsingleFormat} singleFormat={singleFormat} />
        </>
    )
}

export default Preset;
